import { RefreshCw } from "lucide-react";
import { Button } from "./ui/button";
import { cn } from "../lib/utils";
import { useIsMobile } from "../hooks/use-is-mobile";
import MobileIconButton from "./mobile/mobile-icon-button";

interface RefreshToolbarButtonProps {
  isRefreshing: boolean;
  onRefresh: () => void | Promise<unknown>;
  /** Extra disable conditions (e.g. unrelated loading). Button is also disabled while `isRefreshing`. */
  disabled?: boolean;
  className?: string;
}

export function RefreshToolbarButton({
  isRefreshing,
  onRefresh,
  disabled = false,
  className,
}: RefreshToolbarButtonProps) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <MobileIconButton
        label="Refresh"
        disabled={disabled || isRefreshing}
        onClick={() => void onRefresh()}
      >
        <RefreshCw className={cn("h-[18px] w-[18px]", isRefreshing && "animate-spin")} />
      </MobileIconButton>
    );
  }

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className={cn("gap-2", className)}
      disabled={disabled || isRefreshing}
      onClick={() => void onRefresh()}
    >
      <RefreshCw className={cn("h-4 w-4 shrink-0", isRefreshing && "animate-spin")} />
      Refresh
    </Button>
  );
}
